// Barn slug — MUST match the slugify in useTopSaleBarns.ts so mobile links
// resolve to the same get_sale_barn_detail rows as the web barn pages.
// Format: `${state-lower}-${name-slug}` (e.g. "ks-fort-scott-livestock-market").
export function barnSlug(name: string, state: string): string {
  return (
    state.toLowerCase() +
    "-" +
    name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "")
  );
}
